// src/pages/QuizPage/components/QuizLoadingError.tsx
import { useNavigate } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

export function QuizLoading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0E1A]">
      <div className="w-12 h-12 rounded-full border-2 border-blue-500/20 border-t-blue-500 animate-spin" />
    </div>
  );
}

interface QuizErrorProps {
  message: string;
  onRetry?: () => void;
}

export function QuizError({ message, onRetry }: QuizErrorProps) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0E1A] px-4">
      <div className="bg-[#0D1526] border border-red-500/30 p-8 rounded-[32px] max-w-md w-full text-center shadow-2xl">
        <div className="w-20 h-20 rounded-full bg-red-500/20 flex items-center justify-center mx-auto mb-6">
          <AlertTriangle size={40} className="text-red-400" />
        </div>
        <h2 className="text-xl font-black text-white mb-3">Xato yuz berdi</h2>
        <p className="text-gray-400 text-sm mb-6">{message}</p>
        <div className="flex gap-3">
          <button
            onClick={() => navigate(-1)}
            className="flex-1 py-3 bg-white/5 border border-white/10 text-white rounded-2xl font-bold hover:bg-white/10 transition">
            Orqaga
          </button>
          {onRetry && (
            <button
              onClick={onRetry}
              className="flex-1 py-3 bg-blue-600 text-white rounded-2xl font-bold hover:bg-blue-500 transition">
              Qayta urinish
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
